module.exports = __webpack_public_path__ + "img/mision6.cce730fd.png";